import { effect, type InputSignal, type Signal } from '@angular/core';
import { type MatSelect } from '@angular/material/select';

/**
 * Base class for selector components that need required-field validation.
 * Marks the underlying MatSelect as required and triggers an error state
 * when the parent passes hasError=true (e.g. when the bound form control is
 * invalid and touched).
 */
export abstract class SelectErrorState {
  abstract readonly required: InputSignal<boolean>;
  abstract readonly hasError: InputSignal<boolean>;
  protected abstract readonly select: Signal<MatSelect | undefined>;

  constructor() {
    effect(() => {
      const select = this.select();

      if (!select) {
        return;
      }
      select.required = this.required();
      select.stateChanges.next();
    });

    effect(() => {
      const select = this.select();

      if (!select) {
        return;
      }

      select.errorState = this.hasError();
      select.stateChanges.next();
    });
  }

  protected setErrorState(hasError: boolean) {
    const select = this.select();

    if (!select) {
      return;
    }
    select.errorState = hasError;
    select.stateChanges.next();
  }
}
